import http from "./api";

const adminApi = {
  getTravels: () => http.get<AdminTravelBasicItemList>("/admin/travels"),
  getTravel: (id: number) => http.get<AdminTravel>(`/admin/travels/${id}`),
  getTravelBySlug: (slug: string) => http.get<AdminTravel>(`/admin/travels/slug/${slug}`),
  addUpdateTravel: (travel: AdminTravel) => http.post<AdminTravel>(`/admin/travels`, travel),
  deleteTravel: (id: number) => http.delete(`/admin/travels/${id}`),

  getUsers: (params: {
    page?: number,
    pageSize?: number,
    search?: string,
    sortBy?: string,
    sortDirection?: string
  }) => http.get<AdminUserItemList>('/admin/users', { params }),

  getUser: (id: number) => http.get<AdminUser>(`/admin/users/${id}`),
  addUpdateUser: (user: AdminUser) => http.post<AdminUser>(`/admin/users`, user),
  deleteUser: (id: number) => http.delete(`/admin/users/${id}`),
  reactivateUser: (id: number) => http.post<AdminUser>(`/admin/users/${id}/reactivate`),
  checkEmail: (email: string) => http.get<CheckEmailResponse>('/admin/users/check-email', { params: { email } }),

  addParticipant: (userId: number, travelId: number) => http.post<boolean>(`/admin/participants/${travelId}/${userId}`),
  deleteParticipant: (userId: number, travelId: number) => http.delete<boolean>(`/admin/participants/${travelId}/${userId}`),
  deleteParticipants: (travelId: number, userIds: number[]) => http.delete<void>(`/admin/participants/${travelId}/bulk`, { data: { userIds } }),
  searchParticipantToAdd: (travelId: number, query: string, limit = 20) => http.get<AdminUser[]>(`/admin/participants/${travelId}/search`, { params: { search: query, limit: limit } }),

  sendParticipantInvitations: (travelId: number, userIds: number[]) => http.post<ParticipationDb[]>(`/admin/participants/${travelId}/invitations`, { userIds: userIds }),
  sendParticipantReminders: (travelId: number, userIds: number[]) => http.post<ParticipationDb[]>(`/admin/participants/${travelId}/reminders`, { userIds: userIds }),
  getEmailTemplates: () => http.get<EmailTemplateDto[]>('/admin/participants/email-templates'),
  sendParticipantEmail: (travelId: number, request: SendParticipantsEmailRequest) => http.post<SendParticipantsEmailResult>(`/admin/participants/${travelId}/emails`, request),

  importParticipantsExcel: (travelId: number, file: File) => {
    const formData = new FormData()
    formData.append('file', file)
    return http.post<ImportParticipantsResult>(`/admin/participants/${travelId}/import/excel`, formData)
  },

  getParticipantDocuments: (travelId: number, userIds: number[], documentId: number) =>
    http.get<UserFile[]>(`/admin/exports/travel/${travelId}/participants/documents`, {
      params: { userIds, documentId },
      paramsSerializer: { indexes: null },
    }),

  getAllSettings: () => http.get<UserSetting[]>('/admin/settings'),
  saveStringSettings: (setting: UserSetting) => http.post<UserSetting[]>('/admin/settings/save/string', setting),
  saveBoolSettings: (setting: UserSetting) => http.post<UserSetting[]>('/admin/settings/save/bool', setting),

  getBanners: () => http.get<AdminBanner[]>('/admin/banners'),
  saveBanner: (banner: AdminBannerRequest) => http.post<AdminBanner>('/admin/banners', banner),
  deleteBanner: (id: number) => http.delete(`/admin/banners/${id}`),

};

export default adminApi;
